import React, {PropTypes, Component} from 'react';
import {Link} from 'react-router';

class SingleNavigationItem extends Component {
  render() {
    const {active, path, biParams, label, onClick} = this.props;
    return (
      <Link
        to={path} data-hook="singleNavigationItem" data-active={active}
        onClick={() => {
          onClick(biParams);
        }}
        >{label}</Link>
    );
  }
}

SingleNavigationItem.propTypes = {
  path: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  biParams: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default SingleNavigationItem;



// WEBPACK FOOTER //
// ./components/partial/SingleNavigationItem/SingleNavigationItem.js